module.exports = __webpack_public_path__ + "6bacb390c0a16cd873a00e7d6c09ff00.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/apartment-schema.png
// module id = 247
// module chunks = 1